import cookieUtils from '@/intl-jdi-common-ssr/utils/cookieUtils';

const actChannelId = 'actChannelId'; //渠道价活动ID
const crossDeviceId = 'crossDeviceId'; //设备ID

const clearChannelActivityData = () => {
  cookieUtils.deleteCookie(actChannelId);
  cookieUtils.deleteCookie(crossDeviceId);
};

export default clearChannelActivityData;
